import React from 'react';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import { Modal, Button, Icon } from 'rsuite';

export default class DeleteInventoryItemModal extends React.Component {
  static propTypes = {
    item: PropTypes.shape({}),
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    isDeleting: PropTypes.bool.isRequired
  };

  static defaultProps = {
    item: null
  };

  render() {
    const { show, onClose, onConfirm, isDeleting, item } = this.props;
    const name = fp.getOr('...', 'name', item);
    return (
      <Modal backdrop="static" show={show} onHide={this.onClose} size="xs">
        <Modal.Body>
          <Icon icon="exclamation-circle" style={{ color: '#f44336' }} />
          &nbsp; {`Are you sure you want to delete "${name}"?`}
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={onConfirm}
            appearance="primary"
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Yes'}
          </Button>
          <Button onClick={onClose} appearance="subtle">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
